import { settingsApi } from "./settings.api";

export const { useGetSettingsByCompanyQuery, useLazyGetSettingsByCompanyQuery, useUpdateSettingsMutation, useUploadLogoSettingsByCompanyMutation } = settingsApi;
